import { render, staticRenderFns } from "./RoundWarningIcon.vue?vue&type=template&id=222bbd71&"
import script from "./RoundWarningIcon.vue?vue&type=script&lang=js&"
export * from "./RoundWarningIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports